import moment from "moment";

export const setCookie = (cookieName, cookieValue, expiryDays) => {
  const d = new Date();
  d.setTime(d.getTime() + expiryDays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
};

export const getCookie = (cookieName) => {
  let name = cookieName + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

export const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};
export function formatDate(dateString) {
  try {
    const date = moment(dateString);
    return date.format("MMM DD, YYYY").toString();
  } catch {
    return undefined;
  }
}

export const clearAllCookies = () => {
  var cookies = document.cookie.split("; ");
  for (var c = 0; c < cookies.length; c++) {
    var d = window.location.hostname.split(".");
    while (d.length > 0) {
      var cookieBase =
        encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
        "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
        d.join(".") +
        " ;path=";
      var p = window.location.pathname.split("/");
      document.cookie = cookieBase + "/";
      while (p.length > 0) {
        document.cookie = cookieBase + p.join("/");
        p.pop();
      }
      d.shift();
    }
  }
};

const deleteCookie = (name) => {
  setCookie(name, "", -1);
};

const deleteAllCookies = async () => {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++)
    deleteCookie(cookies[i].split("=")[0]);
};

const deleteLocalStorage = async () => {
  const RememberMe = localStorage.getItem("RememberMe");
  const Email = localStorage.getItem("Email");
  const password = localStorage.getItem("password");

  localStorage.clear();
  sessionStorage.clear();

  if (RememberMe === "true") {
    localStorage.setItem("RememberMe", RememberMe);
    localStorage.setItem("Email", Email);
    localStorage.setItem("password", password);
  }
};

export const clearAll = async () => {
  deleteLocalStorage();
  deleteAllCookies();
};

export const GetQueryParams = (query = null) => {
  return (
    decodeURIComponent(window.location.search)
      .replace("?", "")
      // get array of KeyValue pairs
      .split(/&(?!n)/)
      // Decode values
      .map((data) => {
        let [key, val] = data.split("=");
        return [key, decodeURIComponent(val || "")];
      })
      // array to object
      .reduce((result, [key, val]) => {
        result[key] = val;
        return result;
      }, {})
  );
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || typeof phoneNumber !== "string") {
    return "";
  }

  // Remove any non-digit characters from the phone number
  const digitsOnly = phoneNumber.replace(/\D/g, "");

  // Extract the country code and remaining digits
  let country_code = "";
  let remaining_digits = "";

  // Check if there are at least 10 digits in the phone number
  if (digitsOnly.length >= 10) {
    country_code = digitsOnly.slice(0, digitsOnly.length - 10);
    remaining_digits = digitsOnly.slice(digitsOnly.length - 10);
  } else {
    // If less than 10 digits, consider everything as remaining digits
    remaining_digits = digitsOnly;
  }

  // Check if the remaining digits have the correct length (10 digits)
  if (remaining_digits.length !== 10) {
    console.error(
      "Invalid phone number. The remaining digits should be 10 digits long."
    );
    return ""; // Return an empty string or handle the error as needed
  }

  // Format the phone number as desired
  const formattedNumber = `${
    country_code ? "+" + country_code : ""
  }(${remaining_digits.slice(0, 3)}) ${remaining_digits.slice(
    3,
    6
  )}-${remaining_digits.slice(6)}`;

  return formattedNumber;
};

export const getFullStateName = (name) => {
  const data = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
    AS: "American Samoa",
    GU: "Guam",
    MH: "Marshall Islands",
    FM: "Micronesia",
    MP: "Northern Marianas",
    PW: "Palau",
    PR: "Puerto Rico",
    VI: "Virgin Islands",
  };
  return data[name];
};

export const getQuery = (key) => {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(key);
  } catch (error) {
    console.warn("Error", error);
  }
};

export const isNull = (value) => {
  return [null, undefined, "", 0, false, "false", "null"].includes(value);
};

export const getPictureUrl = (pictureUrl = "") => {
  if (!pictureUrl) return;
  if (pictureUrl?.charAt(0) === "/") {
    return `${process.env.REACT_APP_S3_URL}${pictureUrl}`;
  } else {
    return `${process.env.REACT_APP_S3_URL}/${pictureUrl}`;
  }
};

export function convertDate(dateStr) {
  const moment = require("moment");
  try {
    if (!dateStr) return "";
    const parsedDate = moment(dateStr);
    const formattedDate = parsedDate.format("MMM DD, YYYY");
    return formattedDate;
  } catch (error) {
    console.warn(error);
    return "";
  }
}

export const getDeepCopy = (value) => {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (error) {
    return value;
  }
};

export function getRelativeTime(dateValue) {
  try {
    const moment = require("moment");
    let momentDate;

    if (moment(dateValue, moment.ISO_8601, true).isValid()) {
      momentDate = moment(dateValue);
    } else {
      momentDate = moment(parseInt(dateValue, 10));
    }
    return momentDate.fromNow();
  } catch (error) {
    return "Invalid Date";
  }
}

export function getValueFromURLSearchParams(key, url = window.location) {
  try {
    const urlObject = new URL(url);
    const params = new URLSearchParams(urlObject.search);
    const value = params.get(key);
    if (value) {
      const decodedValue = decodeURIComponent(value);
      if (decodedValue.startsWith("[") && decodedValue.endsWith("]")) {
        try {
          return JSON.parse(decodedValue);
        } catch (e) {
          console.error("Error parsing JSON:", e);
          return null;
        }
      }
      return [decodedValue.replace(/\+/g, " ")];
    }
    return null;
  } catch (e) {
    console.error("Invalid URL or error processing URL:", e);
    return null;
  }
}

export const getFullName = (firstName, lastName) => {
  try {
    return `${firstName ? firstName : ""} ${lastName ? lastName : ""}`.trim();
  } catch (error) {
    return "";
  }
};

export const EXPERIENCE_LEVELS = [
  {
    _id: "63ae878e60f52c72dbcba6b3",
    ExperienceLevelId: 1,
    ExperienceLevelCode: "less",
    ExperienceLevelName: "Less than 1 year",
    MinVal: 0,
    MaxVal: 1,
    SortOrder: 1,
    Created: "2015-07-20T21:23:36.160Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.160Z",
    ModifiedBy: 0,
  },
  {
    _id: "63ae878e60f52c72dbcba6b4",
    ExperienceLevelId: 2,
    ExperienceLevelCode: "2",
    ExperienceLevelName: "1-2 years",
    MinVal: 1,
    MaxVal: 2,
    SortOrder: 2,
    Created: "2015-07-20T21:23:36.163Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.163Z",
    ModifiedBy: 0,
  },
  {
    _id: "63ae878e60f52c72dbcba6b5",
    ExperienceLevelId: 3,
    ExperienceLevelCode: "3-5",
    ExperienceLevelName: "3-5 years",
    MinVal: 3,
    MaxVal: 5,
    SortOrder: 3,
    Created: "2015-07-20T21:23:36.167Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.167Z",
    ModifiedBy: 0,
  },
  {
    _id: "6402a5d64c35f236aabb96cb",
    ExperienceLevelId: 4,
    ExperienceLevelCode: "6",
    ExperienceLevelName: "6-10 years",
    MinVal: 6,
    MaxVal: 10,
    SortOrder: 4,
    Created: "2015-07-20T21:23:36.167Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.167Z",
    ModifiedBy: 0,
  },
  {
    _id: "63ae878e60f52c72dbcba6b7",
    ExperienceLevelId: 5,
    ExperienceLevelCode: "more",
    ExperienceLevelName: "More than 10 years",
    MinVal: 10,
    MaxVal: 100,
    SortOrder: 5,
    Created: "2015-07-20T21:23:36.170Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.170Z",
    ModifiedBy: 0,
  },
];
export function capitalizeFirstLetter(string) {
  try {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  } catch {
    return "";
  }
}

export const getCompanyName = (profile) => {
  try {
    const name =
      profile?.PreferredName ||
      profile?.CompanyName ||
      (profile?.FirstName
        ? `${capitalizeFirstLetter(profile?.FirstName)} ${capitalizeFirstLetter(
            profile?.LastName
          )}`
        : null);
    return name;
  } catch (error) {
    return null;
  }
};

export const generateFinalUrl = (
  basePath = "/job-filters",
  accumulatedFilters
) => {
  const searchParams = new URLSearchParams(accumulatedFilters);
  return `${basePath}?${searchParams.toString()}`;
};

export const getGigDetails = () => {
  try {
    const gigDetail = JSON.parse(localStorage.getItem("gigDetail"));
    if (gigDetail) {
      return gigDetail;
    } else {
      return null;
    }
  } catch {}
};

export const decodeSpecialCharacter = (value) => {
  try {
    console.log("value", value, typeof value);
    if (typeof value === "string" || typeof value === "number") {
      return String(value).replace(/-\*/g, "&");
    }
    return value;
  } catch (error) {
    console.log(error);
    return value;
  }
};
